module.exports = __webpack_public_path__ + "img/news-history.7c94b158.png";